// services/user/UserProductService.js
import API from "../../api/apiUser";

const UserProductService = {
  getProducts({
    page = 1,
    limit = 20,
    search = "",
    category = "",
    sort = "popular",
  }) {
    return API.get("/user/products", {
      params: {
        page,
        limit,
        search,
        category,
        sort,
      },
    });
  },

  getProductBySlug(slug) {
    return API.get(`/user/products/slug/${slug}`);
  },
};

export default UserProductService;
